module.exports = __webpack_public_path__ + "static/img/b_logo.b6f5cf82.png";